module.exports = __webpack_public_path__ + "static/media/dot_FFA200.4954206d.svg";